import { Box, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { useTranslation } from 'react-i18next';
import RegistrationImage from '../../../../assets/images/RegistrationLeftImage.png';
import { isHipaaLink } from '../../../../config/productProfile';

import styles from './RegisterLayout.module.scss';

export const RegisterLayout = () => {
  const { t } = useTranslation('auth');

  return (
    <Box className={styles.layoutContainer}>
      <img className={styles.registerImage} src={RegistrationImage} />
      <Typography variant='h1' className={styles.welcomeText}>
        {t('welcome')}
        <br />
        {isHipaaLink ? (
          <>
            {t('to')} HIPAA<span className={styles.link}>LINK</span>
          </>
        ) : (
          <>
            {t('to')} <strong>VIA3</strong>
          </>
        )}
      </Typography>

      <Box className={styles.layoutItem}>
        <CheckIcon />
        <Typography variant='body2'>{t('inviteLayoutLine1')}</Typography>
      </Box>

      <Box className={styles.layoutItem}>
        <CheckIcon />
        <Typography variant='body2'>{t('inviteLayoutLine2')}</Typography>
      </Box>

      <Box className={styles.layoutItem}>
        <CheckIcon />
        <Typography variant='body2'>{t('inviteLayoutLine3')}</Typography>
      </Box>

      {isHipaaLink && (
        <Box className={styles.layoutItem}>
          <CheckIcon />
          <Typography variant='body2'>{t('inviteLayoutLine4')}</Typography>
        </Box>
      )}

      <Box className={styles.layoutItem}>
        <CheckIcon />
        <Typography variant='body2'>{t('inviteLayoutLine5')}</Typography>
      </Box>

      {isHipaaLink && (
        <Box className={styles.layoutItem}>
          <CheckIcon />
          <Typography variant='body2'>{t('inviteLayoutLine6')}</Typography>
        </Box>
      )}

      <Box className={styles.layoutItem}>
        <CheckIcon />
        <Typography variant='body2'>{t('inviteLayoutLine7')}</Typography>
      </Box>
    </Box>
  );
};
